<template>
  <v-dialog v-model="dialogVisible"
    persistent
    max-width="300px" 
  >
    <template #activator="{on}">
      <a v-on="on" style="text-decoration: underline;">{{ linkText }}</a>
    </template>

    <v-card>
      <v-card-text class="pt-6"  v-html="body" style="font-size:12px; line-height: 1.25;"/>

      <v-divider class="mt-n3"/>

      <v-card-actions class="justify-center py-3">
        <v-btn @click="close">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RewardsOtherTextDialog',

  props: {
    body: String,
    linkText: { required: true },
  },

  data: () => ({
    dialogVisible: false,
  }),

  methods: {
    close() {
      this.dialogVisible = false
    },
  },
}
</script>